import { render, staticRenderFns } from "./StoreFloorEdit.vue?vue&type=template&id=2468a884&scoped=true&"
import script from "./StoreFloorEdit.vue?vue&type=script&lang=js&"
export * from "./StoreFloorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468a884",
  null
  
)

export default component.exports